/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { Link } from 'react-router-dom';
import FluentSelect from '../../../../Forms/FluentSelect';
import { Text } from '@fluentui/react';
import { basePath } from '../Helpers/CopyAndFunctions';

const ClientCobrandStep = ({level, cobrandsOptions, clientsOptions}) => (
    <>
    {level === 'client' &&
        <FluentSelect
            options={clientsOptions}
            name="clientId"
            label='Select Clients'
            component={FluentSelect}
        />
    }
    {level === 'cobrand' &&  
        <FluentSelect
            options={cobrandsOptions}
            name="cobrandId"
            label='Select Cobrands'
            component={FluentSelect}
        />
    }    
    <div>
        <Text variant="medium">
            If you can not find a {level}, check the <Link to={`${basePath}/settings`}>settings page.</Link> The custom dashboard feature may be disabled.
        </Text>
    </div>
    </>
);

export default ClientCobrandStep;
